module.exports = __webpack_public_path__ + "img/b5-6.2397c81.png";